const Config = {
  apiEndpoint: "https://mfo3jfojwk.execute-api.eu-central-1.amazonaws.com/dev",
  // apiEndpoint: "http://192.168.68.106:3001",
};

export { Config };
